import { tick } from 'svelte';
/**
 * Grows a textarea to fit `value` (CSS `max-height` caps it, then it scrolls) and snaps back to
 * the CSS min-height immediately once cleared, instead of lingering at its old size. Awaits
 * `tick()` first so `scrollHeight` reflects the value Svelte is about to render, regardless of
 * whether the change came from typing, a programmatic update (emoji insert, clear-on-send), or
 * the byte-limit clamp.
 */
export async function autosizeSupportChatTextarea(el, value) {
    await tick();
    if (!el)
        return;
    if (!value) {
        el.style.height = '';
        return;
    }
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
}
